const initMegaMenu = () => {
    const megaMenuContainer = document.querySelector("[data-mega-menu-container]");
    const megaMenuTogglerContainer = document.querySelector("[data-menu-toggler-container]");
    if (megaMenuContainer && megaMenuTogglerContainer) {
        megaMenuTogglerContainer.addEventListener("click", () => {
            megaMenuContainer.classList.toggle("active");
            megaMenuTogglerContainer.classList.toggle("active");
        });
    }
};
